<div class="cookie-banner-overlay" *ngIf="isVisible" role="dialog" aria-live="polite" aria-label="Consentimiento de cookies">
  <div class="cookie-banner-card">
    <div class="cookie-banner-header">
      <div class="cookie-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"></path>
          <path d="M8.5 8.5v.01"></path>
          <path d="M16 15.5v.01"></path>
          <path d="M12 12v.01"></path>
          <path d="M11 17v.01"></path>
          <path d="M7 14v.01"></path>
        </svg>
      </div>
      <h3 class="cookie-title">Tu privacidad es importante</h3>
    </div>

    <div class="cookie-banner-body">
      <p>
        Utilizamos cookies técnicas necesarias para el funcionamiento del sitio web, así como cookies analíticas y publicitarias de terceros (como Google AdSense) para personalizar anuncios y analizar nuestro tráfico. Puedes aceptar todas o elegir solo las necesarias. Para más información, consulta nuestra 
        <a routerLink="/cookies" class="cookie-link">Política de Cookies</a> y 
        <a routerLink="/privacy" class="cookie-link">Política de Privacidad</a>.
      </p>
    </div>

    <div class="cookie-banner-actions">
      <button type="button" class="btn-cookie-essential" (click)="acceptEssential()">
        Solo necesarias
      </button>
      <button type="button" class="btn-cookie-accept" (click)="acceptAll()">
        Aceptar todas
      </button>
    </div>
  </div>
</div>
